/// <amd-module name="Wit/HtmlEditor/Components/HtmlPreview" />
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { usePageContext } from "VSS/Platform/Layout";
import { convertRawMentionsToRichPreviews, sanitizeExternalLinks } from "../Utils/Mention";
import { makeAllWorkItemHyperlinksClickable } from "../Utils/WorkItemLinks";

export function HtmlPreview({ rawHtml }: { rawHtml: string }) {
    const pageContext = usePageContext();

    const sanitizedHtmlElement = useMemo(() => {
        const element = document.createElement("div");
        element.innerHTML = rawHtml;
        sanitizeExternalLinks(element);
        return element;
    }, [rawHtml]);

    const initialContent = sanitizedHtmlElement.innerHTML;
    const [content, setContent] = useState(initialContent);

    useEffect(() => {
        setContent(sanitizedHtmlElement.innerHTML);

        makeAllWorkItemHyperlinksClickable(sanitizedHtmlElement, pageContext);

        convertRawMentionsToRichPreviews(sanitizedHtmlElement, pageContext).then(() => {
            setContent(sanitizedHtmlElement.innerHTML);
        });
    }, [sanitizedHtmlElement]);

    return <div dangerouslySetInnerHTML={{ __html: content }} />;
}
